import Config from "src/Constants/Config";

import Movies from "src/Component/TV/Movies";
import useClock from "src/Hooks/useClock";
import profiles from "../../../Component/TV/profiles.json";
import { useSelector } from "react-redux";
import store from "src/Reducers/store";
import { useEffect, useState } from "react";
import Pulse from "src/Component/Pulse";
import ProfileAndTime from "src/Component/ProfileAndTime";

import "./index.sass";

interface ScreenProps {
  step: number;
  setStep: (step: number) => void;
  pageId: number;
  bundles: any;
  bundlesPkg: any;
}

const Screen = ({ step, setStep, pageId, bundles, bundlesPkg }: ScreenProps) => {
  const baseImages = `${Config.BASE_URL}/images/screen_${pageId}/`;
  const imgBgScreen = `${baseImages}bg.jpg`;
  const [bigBundles, setBigBundles] = useState<any>([]);
  // const [price, setPrice] = useState<string>("9.99");

  const currentUser = useSelector(() => store.getState().appReducer.currentUser);
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);
  const currentProfile = profiles.find((profile) => profile.key === currentUser);

  const time = useClock();

  useEffect(() => {
    const newBundles = bundles.map((bundle: any) => {
      // if (bundle.pulse && step >= 2) bundle.pulse = false;
      return bundle;
    });
    setBigBundles(newBundles);
  }, [bundles, step]);

  useEffect(() => {
    if (step === 4) setTimeout(() => setStep(5), 300);
    if (step === 5) setTimeout(() => setStep(6), 300);
    if (step === 6) setTimeout(() => setStep(7), 300);
    if (step === 7) setTimeout(() => setStep(8), 800);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  const tvStyle = { position: "absolute" as "absolute", transition: "opacity 0.5s", top: 0, left: 0, width: "100%", height: "100%" };

  const [scrollTo, setScrollTo] = useState<number | undefined>(undefined);

  useEffect(() => {
    const scroll = (window.innerWidth * 650) / 1920;
    if (currentPage === 8) setScrollTo(scroll);
    else setTimeout(() => setScrollTo(0), 10);
  }, [currentPage]);

  return (
    <>
      <ProfileAndTime bg={imgBgScreen} time={time} currentProfile={currentProfile} />
      <div className="screen-8-bundle">
        <Movies scrollTo={scrollTo} size="big" className="homepage-movies" data={bigBundles} handleOnClickPulse={() => setStep(2)} />
      </div>
      <div className="screen-8-small">
        <Movies size="small" className="homepage-movies" data={bundlesPkg} handleOnClickPulse={() => () => {}} />
      </div>
      <img style={{ ...tvStyle, opacity: step >= 2 ? 1 : 0, zIndex: step >= 2 ? 10 : -1 }} src={`${baseImages}tv_0.jpg`} alt="" />
      <img style={{ ...tvStyle, opacity: step >= 3 ? 1 : 0, zIndex: step >= 3 ? 10 : -1 }} src={`${baseImages}tv_1.jpg`} alt="" />
      <img style={{ ...tvStyle, opacity: step >= 4 ? 1 : 0, zIndex: step >= 4 ? 10 : -1 }} src={`${baseImages}tv_2.jpg`} alt="" />
      <img style={{ ...tvStyle, opacity: step >= 5 ? 1 : 0, zIndex: step >= 5 ? 10 : -1 }} src={`${baseImages}tv_3.png`} alt="" />
      <img style={{ ...tvStyle, opacity: step >= 6 ? 1 : 0, zIndex: step >= 6 ? 10 : -1 }} src={`${baseImages}tv_4.png`} alt="" />
      <img style={{ ...tvStyle, opacity: step >= 7 ? 1 : 0, zIndex: step >= 7 ? 10 : -1 }} src={`${baseImages}tv_5.png`} alt="" />
      <img style={{ ...tvStyle, opacity: step >= 8 ? 1 : 0, zIndex: step >= 8 ? 10 : -1 }} src={`${baseImages}tv_6.jpg`} alt="" />

      <div className="screen-8-btn-1" onClick={() => (step === 2 ? setStep(3) : null)}>
        {step === 2 && <Pulse style={{ width: "var(--width-55)" }} />}
      </div>
      <div className="screen-8-btn-2" onClick={() => (step === 3 ? setStep(4) : null)}>
        {step === 3 && <Pulse style={{ width: "var(--width-55)" }} />}
      </div>
    </>
  );
};

export default Screen;
